import React, { useEffect, useRef, useState, useMemo } from "react";
//MUI
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Button, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import eOpsLogo from "../../../images/eops.png";
import excel from "../../../images/excel.png";
import mepcoLogo from "../../../images/mepcoLogo.png";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.jpg";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import pdf from "../../../images/pdf.png";
import print from "../../../images/print.png";
import {
  convertDate,
  convertDatewithTime,
  convertDatewithTimeWithoutSecond,
  printStamp,
  subdivisionName,
  getName,
} from "../../../services/Functions";
import { internalIconStyles } from "../../../style/common";
import "../../../style/common.scss";
//#endregion
import { Autocomplete, TextField } from "@mui/material";
import { cfpBaseUrl } from "../../../network/urls";
const DetailReport = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [officeName, setOfficeName] = useState("MEPCO");
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const {
    userId,
    token,
    cscID,
    permissions,
    code,
    // hierarchy,
    showAllApplicationsFlag,
    name,
    roleName,
    profilePicture,
    roleTypeId,
    phoneNo,
    roleId,
    cnic,
    email,
    divisionCode,
    roleTypeName,
    cfcLevelId,
    hierarchy: hierar,
  } = useSelector((state) => state.auth);
  const offCode =
    hierar == 1
      ? code
      : hierar == 2
      ? code.slice(0, 2)
      : hierar == 3
      ? code.slice(0, 3)
      : hierar == 4
      ? code.slice(0, 4)
      : hierar == 5
      ? code.slice(0, 5)
      : code;
  const tableRef = useRef(null);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [circleName, setCircleName] = useState("");
  const [totals, setTotals] = useState({});
  const [officeCode, setOfficeCode] = useState("");
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const [disco, setDisco] = useState("15");

  const [dateTo, setDateTo] = useState(getCurrentDate());
  const statsTableRef = useRef();
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const { wmsPrivateToken } = useSelector((state) => state.auth);
  const [complaints, setComplaints] = useState([]);
  const [searchText, setSearchText] = useState(""); // Tracks the search bar input
  const [selectedValue, setSelectedValue] = useState(""); // Tracks the selected dropdown value
  const [reportDateFrom, setReportDateFrom] = useState(getCurrentDate());
  const [reportDateTo, setDsetReportDateTo] = useState(getCurrentDate());
  // const tableRef = useRef();
  const [statusFilter, setStatusFilter] = useState("");
  const [sourceFilter, setSourceFilter] = useState("");
  const [registeredBy, setRegisteredBy] = useState("");
  const [complaintCategory, setComplaintCategory] = useState("");
  const [employeeNameFilter, setEmployeeNameFilter] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const uniqueSources = Array.from(
    new Set(complaints.map((item) => item.Source))
  );
  const uniqueRegisteredBy = Array.from(
    new Set(
      complaints
        .map((item) => item.RegisteredBy?.trim()) // remove extra spaces
        .filter((val) => val && val !== "") // remove null/undefined/empty
    )
  );

  const uniqueCategories = Array.from(
    new Set(
      complaints
        .map((item) => item.ComplaintType?.trim()) // remove extra spaces
        .filter((val) => val && val !== "") // remove null/undefined/empty
    )
  );

  const companyCode = code.slice(0, 2);
  const handleSourceChange = (e) => {
    const selectedSource = e.target.value;
    setSourceFilter(selectedSource);
  };
  const handleRegisteredByChange = (e) => {
    const selectedRegisteredBy = e.target.value;
    setRegisteredBy(selectedRegisteredBy);
  };

  const handleComplaintCategory = (e) => {
    const selectedCategory = e.target.value;
    setComplaintCategory(selectedCategory);
  };

  const uniqueStatus = Array.from(
    new Set(complaints.map((item) => item.Status))
  );

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatusFilter(selectedStatus);
  };

  const handleSort = (order) => {
    setSortOrder(order);
  };

  const sortedComplaints = (complaints) => {
    return complaints.sort((a, b) => {
      if (sortOrder === "asc") {
        return a.Status.localeCompare(b.Status);
      } else {
        return b.Status.localeCompare(a.Status);
      }
    });
  };
  const shifts = [
    { name: "Shift - 1 (6 am - 2 pm)", start: 6, end: 14 },
    { name: "Shift - 2 (2 pm - 10 pm)", start: 14, end: 22 },
    { name: "Shift - 3 (10 pm - 12 am)", start: 22, end: 24 },
    { name: "Shift - 4 (12 am - 6 am)", start: 0, end: 6 },
  ];

  // Organizing complaints into shifts
  const organizedComplaints = {
    "Shift - 1": [],
    "Shift - 2": [],
    "Shift - 3": [],
    "Shift - 4": [],
  };

  complaints.forEach((complaint) => {
    const registeredAtHour = new Date(complaint.RegisteredAt).getHours();
    if (
      registeredAtHour >= shifts[0].start &&
      registeredAtHour < shifts[0].end
    ) {
      organizedComplaints["Shift - 1"].push(complaint);
    } else if (
      registeredAtHour >= shifts[1].start &&
      registeredAtHour < shifts[1].end
    ) {
      organizedComplaints["Shift - 2"].push(complaint);
    } else if (
      registeredAtHour >= shifts[2].start &&
      registeredAtHour < shifts[2].end
    ) {
      organizedComplaints["Shift - 3"].push(complaint);
    } else {
      organizedComplaints["Shift - 4"].push(complaint);
    }
  });

  const filteredComplaints = complaints.filter(
    (complaint) =>
      (statusFilter === "" ||
        complaint.Status.toLowerCase().replace(/\s+/g, "") ===
          statusFilter.toLowerCase().replace(/\s+/g, "")) &&
      (sourceFilter === "" || complaint.Source === sourceFilter) &&
      (selectedValue === "" || complaint.UserFullName === selectedValue) &&
      (registeredBy === "" ||
        String(complaint.RegisteredBy) === registeredBy) &&
      (complaintCategory === "" ||
        complaint.ComplaintType === complaintCategory)
  );

  const getStats = async (finalCode, dateFrom, dateTo) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        pageNumber: "1",
        pageSize: "100000",
        SubDivisionCode: finalCode,
        dateFrom: dateFrom ? dateFrom : "",
        dateTo: dateTo,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl +
          "lineComplaints/GetAllComplaintsBySubDivisionWithoutStatus",
        requestOptions
      );
      const result = await response.json();

      if (result.status == "200") {
        const Data = result.data;
        if (Data) {
          setComplaints(Data);
        }
      } else {
        setComplaints([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setViewBackdrop(false);
    }
  };

  const formatTableData = (data) => {
    const groupedData = {};

    data.forEach((item) => {
      const { status, complaintType, count } = item;

      if (!groupedData[status]) {
        groupedData[status] = {
          total: {},
        };
      }

      groupedData[status].total[complaintType] = count;
    });

    return groupedData;
  };

  const getLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "16":
        return PESCOLOGO;
      case "27":
        return SEPCOLOGO;
      case "37":
        return HESCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  const getCompanies = (code) => {
    switch (code) {
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "16":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
      default:
        return "Multan Electric Power Company";
    }
  };

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);
      const title = `From: ${reportDateFrom} To: ${reportDateTo}`;

      const headers = [
        [
          { content: "Sr. No.", rowSpan: 2, styles: { halign: "center" } },
          { content: "Complaint", colSpan: 3, styles: { halign: "center" } },
          {
            content: "Reference No.",
            rowSpan: 2,
            styles: { halign: "center" },
          },
          // { content: 'Name & Address', rowSpan: 2, styles: { halign: 'center' } },
          // { content: 'Ph. No.', rowSpan: 2, styles: { halign: 'center' } },
          {
            content: "Complaint Type",
            rowSpan: 2,
            styles: { halign: "center" },
          },
          { content: "Allocated At", rowSpan: 2, styles: { halign: "center" } },
          { content: "Dependency", rowSpan: 2, styles: { halign: "center" } },
          { content: "Allocated To", rowSpan: 2, styles: { halign: "center" } },
          { content: "Resolved By", rowSpan: 2, styles: { halign: "center" } },
          // { content: 'Updated At', rowSpan: 2, styles: { halign: 'center' } },
          {
            content: "Complaint Resolved",
            colSpan: 3,
            styles: { halign: "center" },
          },
          { content: "Status", rowSpan: 2, styles: { halign: "center" } },
          { content: "TAC KPI Time", rowSpan: 2, styles: { halign: "center" } },
          { content: "Source", rowSpan: 2, styles: { halign: "center" } },
        ],
        [
          { content: "Time", styles: { halign: "center" } },
          { content: "ID.", styles: { halign: "center" } },
          { content: "By", styles: { halign: "center" } },
          { content: "At", styles: { halign: "center" } },
          { content: "By", styles: { halign: "center" } },
          { content: "Remarks", styles: { halign: "center" } },
        ],
      ];

      const body = [];

      ["Shift - 4", "Shift - 1", "Shift - 2", "Shift - 3"].forEach(
        (shiftName) => {
          const shiftComplaints = organizedComplaints[shiftName] || [];
          if (shiftComplaints.length > 0) {
            // Apply filters to complaints based on selected employee value
            const filteredComplaints = shiftComplaints.filter(
              (complaint) =>
                (statusFilter === "" ||
                  complaint.Status.toLowerCase().replace(/\s+/g, "") ===
                    statusFilter.toLowerCase().replace(/\s+/g, "")) &&
                (sourceFilter === "" || complaint.Source === sourceFilter) &&
                (selectedValue === "" ||
                  complaint.UserFullName === selectedValue) &&
                (registeredBy === "" ||
                  complaint.RegisteredBy === registeredBy) &&
                (complaintCategory === "" ||
                  complaint.ComplaintType === complaintCategory)
            );

            const sortedFilteredComplaints =
              sortedComplaints(filteredComplaints);

            if (sortedFilteredComplaints.length > 0) {
              let totalTimeInMs = 0;
              let count = 0;

              sortedFilteredComplaints.forEach((complaint) => {
                if (complaint.AllocationDateTime) {
                  const registeredAt = new Date(complaint.RegisteredAt);
                  const allocationDateTime = new Date(
                    complaint.AllocationDateTime
                  );
                  totalTimeInMs += allocationDateTime - registeredAt;
                  count++;
                }
              });

              const averageTimeInMs = count > 0 ? totalTimeInMs / count : 0;
              const averageDays = Math.floor(
                averageTimeInMs / (1000 * 60 * 60 * 24)
              );
              const averageHours = Math.floor(
                (averageTimeInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              const averageMinutes = Math.floor(
                (averageTimeInMs % (1000 * 60 * 60)) / (1000 * 60)
              );

              const displayShiftName =
                shiftName === "Shift - 4"
                  ? "..... Continued from Shift-3"
                  : shiftName;

              body.push([
                {
                  content: `${displayShiftName} (Average Allocation Time: ${
                    count > 0
                      ? `${averageDays}d ${averageHours}h ${averageMinutes}m`
                      : "N/A"
                  })`,
                  colSpan: 14,
                  styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fillColor: "#f0f8ff",
                    fontSize: 10,
                  },
                },
              ]);

              sortedFilteredComplaints.forEach((complaint, index) => {
                const timeDifference = complaint.AllocationDateTime
                  ? (() => {
                      const registeredAt = new Date(complaint.RegisteredAt);
                      const allocationDateTime = new Date(
                        complaint.AllocationDateTime
                      );
                      const differenceInMs = allocationDateTime - registeredAt;
                      const days = Math.floor(
                        differenceInMs / (1000 * 60 * 60 * 24)
                      );
                      const hours = Math.floor(
                        (differenceInMs % (1000 * 60 * 60 * 24)) /
                          (1000 * 60 * 60)
                      );
                      const minutes = Math.floor(
                        (differenceInMs % (1000 * 60 * 60)) / (1000 * 60)
                      );
                      return `${days}d ${hours}h ${minutes}m`;
                    })()
                  : "-";

                const row = [
                  index + 1,
                  convertDatewithTimeWithoutSecond(complaint.RegisteredAt) ||
                    "-",
                  complaint.EOpsTrackingId || "-",
                  complaint.RegisteredBy || "-",
                  complaint.RefNo || "-",
                  // complaint.Name + ', ' + complaint.Address || '-',
                  // complaint.Mobile || '-',
                  complaint.ComplaintType || "-",
                  complaint.AllocationDateTime != null
                    ? convertDatewithTimeWithoutSecond(
                        complaint.AllocationDateTime
                      )
                    : "-",
                  complaint.dependency || "-",
                  complaint.allocatedTo || "-",
                  complaint.resolvedBy || "-",
                  // convertDatewithTimeWithoutSecond(complaint.ModificationDateTime) || '-',
                  complaint.Status === "Resolved"
                    ? convertDatewithTimeWithoutSecond(
                        complaint.ModificationDateTime
                      )
                    : "-",
                  complaint.UserFullName || "-",
                  complaint.LinemanRemarks || "-",
                  complaint.Status || "-",
                  timeDifference,
                  complaint.Source || "-",
                ];
                body.push(row);
              });
            }
          }
        }
      );

      if (body.length === 0) {
        body.push([
          {
            content: "No Data Found",
            colSpan: 16,
            styles: {
              halign: "center",
              fontSize: 10,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      // Create a new jsPDF instance
      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(10);

      const marginRight = 10;
      const nameText = "Name: " + name;
      const designationText = "Designation: " + roleName;

      const nameWidth = pdf.getTextWidth(nameText);
      const designationWidth = pdf.getTextWidth(designationText);
      const textX =
        pageWidth - Math.max(nameWidth, designationWidth) - marginRight;

      pdf.text(convertDatewithTime(new Date()), textX, 12);
      pdf.text(nameText, textX, 17);
      pdf.text(designationText, textX, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      if (code == 52) {
        pdf.text(
          `Complaint Log for ( ${subdivisionName(
            hierarchy == 52 ? parseInt(code) : 15171,
            subDivisions
          )} Subdivision )`,
          pageWidth / 2,
          18,
          { align: "center" }
        );
      } else {
        pdf.text(`Complaint Log`, pageWidth / 2, 18, { align: "center" });
      }

      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });

      const adjustedColumnStyles = {
        0: { cellWidth: 8, halign: "center" },
        1: { cellWidth: 16, halign: "center" },
        2: { cellWidth: 16, halign: "center" },
        3: { cellWidth: 20, halign: "center" },
        4: { cellWidth: 26, halign: "center" },
        5: { cellWidth: 20, halign: "center" },
        6: { cellWidth: 20, halign: "center" },
        7: { cellWidth: 20, halign: "center" },
        8: { cellWidth: 20, halign: "center" },
        9: { cellWidth: 20, halign: "center" },
        10: { cellWidth: 20, halign: "center" },
        11: { cellWidth: 20, halign: "center" },
        12: { cellWidth: 15, halign: "center" },
        13: { cellWidth: 10, halign: "center" },
        14: { cellWidth: 10, halign: "center" },
        15: { cellWidth: 10, halign: "center" },
      };

      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: { cellPadding: 1, fontSize: 8 },
        headStyles: { halign: "center", valign: "middle" },
        margin: { top: 2 },
        theme: "striped",
        columnStyles: adjustedColumnStyles,
        didDrawPage: function (data) {},
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(`${offName}-${dateToPrint}-Complaint-Log.pdf`);
        resolve(null);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `From ${reportDateFrom} to ${reportDateTo} - Complaint-Log.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      officeCode:
        hierarchy == 1
          ? "10"
          : hierarchy == 2
          ? code.slice(0, 2)
          : hierarchy == 3
          ? code.slice(0, 3)
          : hierarchy == 4
          ? code.slice(0, 4)
          : hierarchy == 52
          ? code
          : code.slice(0, 5),
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "workForce/getAllEmployeesList", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.message === "Data Found.") {
          setData(result.data);
        } else {
          console.log("Error: Status not 200", result);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(error);
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   if (dateFrom, dateTo) {

  //     setReportDateFrom(dateFrom)
  //     setDsetReportDateTo(reportDateTo)
  //     getStats(offCode, dateFrom, dateTo)
  //   }
  // }, [])

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setLoading(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setLoading(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const employeeOptions = useMemo(() => {
    return Array.isArray(data) && data.length > 0
      ? [...new Set(data.map((user) => user.employeeName || ""))].sort((a, b) =>
          a.localeCompare(b)
        )
      : [];
  }, [data]);

  // Filter dropdown options based on the search text
  const filteredOptions = useMemo(() => {
    if (!searchText) return employeeOptions;
    return employeeOptions.filter((name) =>
      name.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, employeeOptions]);
  const addVibrationAnimation = () => {
    const style = document.createElement("style");
    style.innerHTML = `
            @keyframes zoomInOut {
                0% { transform: scale(1); }
                50% { transform: scale(1.1); }
                100% { transform: scale(1); }
            }
        `;
    document.head.appendChild(style);
  };
  useEffect(() => {
    addVibrationAnimation();
  }, []);

  const currentFilters = {
    officeCode,
    dateFrom,
    dateTo,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [officeCode, dateFrom, dateTo]);

  const handleGoClick = () => {
    getStats(officeCode, dateFrom, dateTo);
    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };
  return (
    <>
      {/* Applications Table */}
      <Box className="form-box">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Box className="application-table" style={{ marginRight: "10px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                  Complaint Log
                </h3>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                 <div
                    onClick={() => {
                      if (filteredComplaints.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (filteredComplaints.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (filteredComplaints.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
              </div>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',margin: "20px 0" }}>
                <div style={{display:'flex',gap:'5px'}}>
                  <div className="field-container">
                    <Typography className="field-label"> Date From</Typography>
                    <input
                      type="date"
                      className="date-field"
                      value={dateFrom}
                      style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                      onChange={(e) => {
                        setDateFrom(e.target.value);
                      }}
                    />
                  </div>
                  <div className="field-container">
                    <Typography className="field-label"> Date To</Typography>
                    <input
                      type="date"
                      className="date-field"
                      value={dateTo}
                      style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => {
                        setDateTo(e.target.value);
                      }}
                    />
                  </div>
                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                       style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={selectedCompanyCode}
                        onChange={(e) => {
                          handleChangeCompany(e);
                        }}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                       style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={circleCode || ""}
                        onChange={(e) => {
                          handleCircleChange(e);
                        }}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={selectedDivision || ""}
                        onChange={(e) => {
                          handleDivisionChange(e);
                        }}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                       style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={selectedSubDivision || ""}
                        onChange={(e) => {
                          handleSubDivisionChange(e);
                        }}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div  style={{ marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      color="primary"
                     
                      onClick={handleGoClick}
                      disabled={isGoDisabled || viewBackdrop}
                    >
                      Go
                    </Button>
                  </div>
                 
                </div>
                <div style={{display:'flex',gap:'5px'}}>
                   {uniqueCategories.length > 0 && (
                    <div className="field-container">
                      <Typography sx={{ color: "grey" }}> Category</Typography>
                      <select
                        id="sourceDropdown"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={complaintCategory}
                        onChange={handleComplaintCategory}
                      >
                        <option value="">All</option>
                        {uniqueCategories.map((categories, index) => (
                          <option key={index} value={categories}>
                            {categories}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy != 2 && filteredOptions?.length > 0 && (
                    <div className="field-container">
                      <Typography className="field-label"> LM Name:</Typography>
                      <Autocomplete
                        options={filteredOptions}
                        value={selectedValue || ""}
                        onInputChange={(event, value) => {
                          setSearchText(value); // Updates search text as user types
                        }}
                        onChange={(event, newValue) => {
                          setSelectedValue(newValue || ""); // Updates selected value
                          setSearchText(""); // Clears search text on selection
                        }}
                        clearOnEscape
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search"
                            variant="outlined"
                            fullWidth
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                height: "30px", // Adjust input height
                                fontSize: "14px", // Font size of the text
                                padding: "0 10px", // Horizontal padding for proper spacing
                                lineHeight: "normal", // Ensure proper line height
                                display: "flex",
                                alignItems: "center", // Vertically center the text
                              },
                            }}
                            inputProps={{
                              ...params.inputProps, // Important: Use params.inputProps to avoid conflicts
                              style: {
                                padding: "0", // Remove extra padding for proper alignment
                              },
                            }}
                          />
                        )}
                        sx={{
                          "& .MuiAutocomplete-clearIndicator": {
                            left: "5px",
                            right: "auto",
                          },
                          "& .MuiAutocomplete-inputRoot": {
                            padding: "0 10px",
                          },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "4px",
                          },
                        }}
                        style={{
                          width: 150,
                          backgroundColor: "white",
                        }}
                      />
                    </div>
                  )}
                  {uniqueStatus.length > 0 && (
                    <div className="field-container">
                      <Typography sx={{ color: "grey" }}> Status:</Typography>
                      <select
                        id="sourceDropdown"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={statusFilter}
                        onChange={handleStatusChange}
                      >
                        <option value="">All</option>
                        {uniqueStatus.map((Status, index) => (
                          <option key={index} value={Status}>
                            {Status}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {uniqueSources.length > 0 && (
                    <div className="field-container">
                      <Typography sx={{ color: "grey" }}> Source:</Typography>
                      <select
                        id="sourceDropdown"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={sourceFilter}
                        onChange={handleSourceChange}
                      >
                        <option value="">All</option>
                        {uniqueSources.map((source, index) => (
                          <option key={index} value={source}>
                            {source}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {uniqueRegisteredBy.length > 0 && (
                    <div className="field-container">
                      <Typography sx={{ color: "grey" }}>
                        {" "}
                        Registered By
                      </Typography>
                      <select
                        id="sourceDropdown"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          width: "150px",
                          padding: "5px 10px",
                        }}
                        value={registeredBy}
                        onChange={handleRegisteredByChange}
                      >
                        <option value="">All</option>
                        {uniqueRegisteredBy.map((RegisteredBy, index) => (
                          <option key={index} value={RegisteredBy}>
                            {RegisteredBy}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            <div className="div-datagrid" style={{ marginBottom: "1000px" }}>
              

              <table
                ref={tableRef}
                className="table"
                style={{ marginBottom: "10px" }}
              >
                <thead>
                  <tr>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                        fontSize: "14px",
                      }}
                    >
                      Sr.
                      <br /> No.
                    </th>
                    <th
                      colSpan="3"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Complaint
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Reference <br /> No.
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Name &<br />
                      Address
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Ph.
                      <br />
                      No.
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Complaint <br /> Type
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Allocated
                      <br />
                      At
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Dependency
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Allocated
                      <br />
                      To
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Resolved
                      <br />
                      By
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Updated <br />
                      At
                    </th>
                    <th
                      colSpan="3"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Complaint Resolved
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                        textAlign: "center",
                        verticalAlign: "top",
                      }}
                    >
                      <div
                        style={{
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Status
                      </div>
                      <div
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <KeyboardArrowUpIcon
                          style={{ cursor: "pointer", display: "block" }}
                          onClick={() => handleSort("asc")}
                        />
                        <KeyboardArrowDownIcon
                          style={{ cursor: "pointer", display: "block" }}
                          onClick={() => handleSort("desc")}
                        />
                      </div>
                    </th>

                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      TAC KPI Time
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Comp. KPI Time
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#d5e5ff",
                        color: "black",
                      }}
                    >
                      Source
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#eeeff1",
                        color: "black",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Time
                    </th>
                    <th
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#eeeff1",
                        color: "black",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      ID.
                    </th>
                    <th
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#eeeff1",
                        color: "black",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      By
                    </th>
                    <th
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#eeeff1",
                        color: "black",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      At
                    </th>
                    <th
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#eeeff1",
                        color: "black",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      By
                    </th>
                    <th
                      style={{
                        border: "5px solid white",
                        backgroundColor: "#eeeff1",
                        color: "black",
                        width: "150px",
                        textAlign: "center",
                      }}
                    >
                      Remarks
                    </th>
                  </tr>
                </thead>
                <tbody style={{ marginBottom: "20px" }}>
                  {filteredComplaints.length === 0 ? (
                    <tr>
                      <td
                        colSpan="20"
                        style={{
                          textAlign: "center",
                          padding: "10px",
                          fontSize: "16px",
                          color: "red",
                        }}
                      >
                        No data found
                      </td>
                    </tr>
                  ) : (
                    ["Shift - 4", "Shift - 1", "Shift - 2", "Shift - 3"]
                      .filter((shiftName) => {
                        const shiftComplaints =
                          organizedComplaints[shiftName] || [];
                        const shiftFilteredComplaints = shiftComplaints.filter(
                          (complaint) =>
                            (statusFilter === "" ||
                              complaint.Status.toLowerCase().replace(
                                /\s+/g,
                                ""
                              ) ===
                                statusFilter
                                  .toLowerCase()
                                  .replace(/\s+/g, "")) &&
                            (sourceFilter === "" ||
                              complaint.Source === sourceFilter) &&
                            (selectedValue === "" ||
                              complaint.UserFullName === selectedValue) &&
                            (registeredBy === "" ||
                              complaint.RegisteredBy === registeredBy) &&
                            (complaintCategory === "" ||
                              complaint.ComplaintType === complaintCategory)
                        );
                        return shiftFilteredComplaints.length > 0;
                      })
                      .map((shiftName, index) => {
                        const shiftComplaints =
                          organizedComplaints[shiftName] || [];
                        const shiftFilteredComplaints = sortedComplaints(
                          shiftComplaints.filter(
                            (complaint) =>
                              (statusFilter === "" ||
                                complaint.Status.toLowerCase().replace(
                                  /\s+/g,
                                  ""
                                ) ===
                                  statusFilter
                                    .toLowerCase()
                                    .replace(/\s+/g, "")) &&
                              (sourceFilter === "" ||
                                complaint.Source === sourceFilter) &&
                              (selectedValue === "" ||
                                complaint.UserFullName === selectedValue) &&
                              (registeredBy === "" ||
                                complaint.RegisteredBy === registeredBy) &&
                              (complaintCategory === "" ||
                                complaint.ComplaintType === complaintCategory)
                          )
                        );

                        let totalTimeInMs = 0;
                        let count = 0;

                        shiftFilteredComplaints.forEach((complaint) => {
                          if (complaint.AllocationDateTime) {
                            const registeredAt = new Date(
                              complaint.RegisteredAt
                            );
                            const allocationDateTime = new Date(
                              complaint.AllocationDateTime
                            );
                            totalTimeInMs += allocationDateTime - registeredAt;
                            count++;
                          }
                        });

                        const averageTimeInMs =
                          count > 0 ? totalTimeInMs / count : 0;
                        const averageDays = Math.floor(
                          averageTimeInMs / (1000 * 60 * 60 * 24)
                        );
                        const averageHours = Math.floor(
                          (averageTimeInMs % (1000 * 60 * 60 * 24)) /
                            (1000 * 60 * 60)
                        );
                        const averageMinutes = Math.floor(
                          (averageTimeInMs % (1000 * 60 * 60)) / (1000 * 60)
                        );

                        const displayShiftName =
                          shiftName === "Shift - 4"
                            ? "..... Continued from Shift-3"
                            : shiftName;

                        return (
                          <React.Fragment key={`shift-${index}`}>
                            <tr style={{ backgroundColor: "#f0f8ff" }}>
                              <td
                                colSpan="16"
                                style={{
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  padding: "10px",
                                }}
                              >
                                {displayShiftName} ( Average Allocation Time:{" "}
                                {count > 0
                                  ? `${averageDays}d ${averageHours}h ${averageMinutes}m`
                                  : "N/A"}
                                )
                              </td>
                            </tr>
                            {shiftFilteredComplaints.map((type, idx) => (
                              <tr
                                key={idx}
                                style={{
                                  border: "5px solid white",
                                  backgroundColor: "white",
                                }}
                              >
                                <td
                                  style={{
                                    width: "50px",
                                    textAlign: "left",
                                    border: "5px solid white",
                                  }}
                                >
                                  {idx + 1}
                                </td>
                                <td
                                  style={{
                                    width: "150px",
                                    textAlign: "left",
                                    border: "5px solid white",
                                  }}
                                >
                                  {new Date(type.RegisteredAt).toLocaleString()}
                                </td>
                                <td
                                  style={{
                                    width: "120px",
                                    textAlign: "left",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.EOpsTrackingId}
                                </td>
                                <td
                                  style={{
                                    width: "120px",
                                    textAlign: "left",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.RegisteredBy == "" ||
                                  type.RegisteredBy == null
                                    ? type.Source
                                    : type.RegisteredBy}
                                </td>

                                <td
                                  style={{
                                    width: "140px",
                                    textAlign: "left",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.RefNo}
                                </td>
                                <td
                                  style={{
                                    width: "320px",
                                    textAlign: "left",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.Name + ", " + type.Address}
                                </td>
                                <td
                                  style={{
                                    width: "120px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.Mobile}
                                </td>
                                <td
                                  style={{
                                    width: "250px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.ComplaintType}
                                </td>
                                <td
                                  style={{
                                    width: "80px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.AllocationDateTime
                                    ? new Date(
                                        type.AllocationDateTime
                                      ).toLocaleString()
                                    : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "80px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.dependency ? type.dependency : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "80px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.allocatedTo ? type.allocatedTo : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "150px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.resolvedBy ? type.resolvedBy : "-"}
                                </td>
                                {/* <td
  style={{
    width: "120px",
    textAlign: "left",
    border: "5px solid white",
  }}
>
  { (type.resolvedBy == "" || type.resolvedBy == null) && type.Status == "Resolved"
    ? (["CCMS_Walk In Customer", "CCMS_IVR", "CCMS_SMS", "CCMS_Mobile App", "CCMS_Call Center"].includes(type.Source) 
        ? "CCMS"
        : type.resolvedBy)
    : type.resolvedBy || "-"}
</td> */}

                                <td
                                  style={{
                                    width: "80px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.ModificationDateTime
                                    ? new Date(
                                        type.ModificationDateTime
                                      ).toLocaleString()
                                    : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "150px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.Status === "Resolved"
                                    ? new Date(
                                        type.ModificationDateTime
                                      ).toLocaleString()
                                    : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.UserFullName}
                                </td>
                                <td
                                  style={{
                                    width: "250px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.LinemanRemarks}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    backgroundColor:
                                      type.Status === "Resolved"
                                        ? "#bbf3de"
                                        : type.Status === "Pending"
                                        ? "#ffe2e5"
                                        : type.Status === "Allocated"
                                        ? "#bbf3ff"
                                        : type.Status === "Working"
                                        ? "#ebdbfe"
                                        : type.Status.toLowerCase().replace(
                                            /\s+/g,
                                            ""
                                          ) === "onhold"
                                        ? "#fef5c0"
                                        : type.Status === "New"
                                        ? "#333333"
                                        : type.Status === "Reopen"
                                        ? "#ffa75b"
                                        : "white",
                                    color:
                                      type.Status === "Resolved"
                                        ? "#24a574"
                                        : type.Status === "Pending"
                                        ? "#c41728"
                                        : type.Status === "Allocated"
                                        ? "#128299"
                                        : type.Status === "Working"
                                        ? "#8647d3"
                                        : type.Status.toLowerCase().replace(
                                            /\s+/g,
                                            ""
                                          ) === "onhold"
                                        ? "#c4a911"
                                        : type.Status === "New"
                                        ? "white"
                                        : type.Status === "Reopen"
                                        ? "white"
                                        : "white",
                                    border: "none",
                                    padding: "5px 10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    borderRadius: "10px",
                                    marginTop: "8px",
                                    animation:
                                      type.Status === "New" ||
                                      type.Status === "Reopen"
                                        ? "zoomInOut 0.6s infinite alternate ease-in-out"
                                        : "none",
                                  }}
                                >
                                  {type.Status}
                                </td>
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.AllocationDateTime
                                    ? (() => {
                                        const registeredAt = new Date(
                                          type.RegisteredAt
                                        );
                                        const allocationDateTime = new Date(
                                          type.AllocationDateTime
                                        );
                                        const differenceInMs =
                                          allocationDateTime - registeredAt;
                                        const days = Math.floor(
                                          differenceInMs / (1000 * 60 * 60 * 24)
                                        );
                                        const hours = Math.floor(
                                          (differenceInMs %
                                            (1000 * 60 * 60 * 24)) /
                                            (1000 * 60 * 60)
                                        );
                                        const minutes = Math.floor(
                                          (differenceInMs % (1000 * 60 * 60)) /
                                            (1000 * 60)
                                        );
                                        return `${days}d ${hours}h ${minutes}m`;
                                      })()
                                    : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.Status === "Resolved" &&
                                  type.AllocationDateTime &&
                                  type.ModificationDateTime
                                    ? (() => {
                                        const allocationDateTime = new Date(
                                          type.AllocationDateTime
                                        );
                                        const modificationDateTime = new Date(
                                          type.ModificationDateTime
                                        );
                                        const differenceInMs =
                                          modificationDateTime -
                                          allocationDateTime;
                                        const days = Math.floor(
                                          differenceInMs / (1000 * 60 * 60 * 24)
                                        );
                                        const hours = Math.floor(
                                          (differenceInMs %
                                            (1000 * 60 * 60 * 24)) /
                                            (1000 * 60 * 60)
                                        );
                                        const minutes = Math.floor(
                                          (differenceInMs % (1000 * 60 * 60)) /
                                            (1000 * 60)
                                        );
                                        return `${days}d ${hours}h ${minutes}m`;
                                      })()
                                    : "-"}
                                </td>
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    border: "5px solid white",
                                  }}
                                >
                                  {type.Source}
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        );
                      })
                  )}
                  <tr style={{ height: "40px" }}></tr>
                </tbody>
              </table>
            </div>
          </Box>
        </div>
      </Box>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default DetailReport;
